import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   rxApps: {},
   rxAppData: {},
};


export const appCenterSlice = createSlice({
  name: 'appCenter',
  initialState,
  reducers: {
    setRxApps: (state, action) => {
      state.rxApps = action.payload;
    },
    setRxAppData: (state, action) => {
      state.rxAppData = action.payload;
    },
  }
});

export const {
  setRxApps,
  setRxAppData,
} = appCenterSlice.actions;

export const getRxApps = (state) => state.appCenter.rxApps;
export const getRxAppData = (state) => state.appCenter.rxAppData;
export default appCenterSlice.reducer;
